const MUTATION_TYPE = {
  setContacts: 'setContacts'
}

const ACTION_TYPE = {
  fetchContacts: 'fetchContacts'
}

const GETTER_TYPE = {
  getContacts: 'getContacts'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
